<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title class="font-weight-bold text-wrap">
        Consulta de disponibilidad de empleado
      </v-toolbar-title>
    </v-toolbar>
    <v-divider />

    <form-buscar-empleado
      ref="refFormBuscarEmpleado"
      @limpiar-formulario="limpiarFormulario"
      @update-identificacion="actualizarIdentificacionInput"
      @submit-form="consultarEmpleado"
      :deshabilita-input="loadingConsulta"
    >
      <template v-slot:botones>
        <v-btn
          class="text-capitalize"
          color="primary"
          :disabled="estaBotonConsultarDeshabilitado"
          @click="consultarEmpleado"
        >
          <template v-slot:default>
            <v-progress-circular
              v-if="loadingConsulta"
              indeterminate
              size="20"
              :width="3"
              class="mr-2"
            />
            <span>
              {{ loadingConsulta ? 'Consultando ' : 'Consultar' }}
            </span>
          </template>
        </v-btn>
      </template>
    </form-buscar-empleado>
    <card-datos-empleado
      v-if="puedeVerCardDatosEmpleado"
      :datos-empleado-card="datosEmpleadoCard.empleadoCard"
    />

    <disponibilidad-creditos
      v-if="puedeVerDisponibilidadCreditos"
      :convenios="disponibilidadCreditosCard.convenios"
      :empleado="disponibilidadCreditosCard.empleadoData"
    />

    <alert-empleado-no-registrado
      v-if="empleadoNoRegistradoAlert.showAlert"
      :empleado-no-registrado-mensaje="empleadoNoRegistradoAlert.mensaje"
      :identificacion-input="empleadoNoRegistradoAlert.identificacion"
    />

    <alert-datos-desactualizados
      v-if="datosDesactualizadosAlert.showAlert"
      :empleado-datos-desactualizados="datosDesactualizadosAlert.empleadoAlert"
    />

    <v-container
      v-if="empleadoRetiradoAlert.showAlert"
      class="d-flex justify-center"
    >
      <v-alert outlined type="info" border="bottom">
        El empleado se encuentra retirado
      </v-alert>
    </v-container>
  </v-card>
</template>

<script>
import empleadoService from '../../../Services/empleadoService';
import empresaService from '../../../Services/empresaService';
import usuarioService from '../../../Services/usuarioService';
import { empresaEstaActualizada } from '../../../utils/actualizacionEmpresaUtil';
import AlertDatosDesactualizados from './Alerts/DatosDesactualizados.vue';
import AlertEmpleadoNoRegistrado from './Alerts/EmpleadoNoRegistrado.vue';
import FormBuscarEmpleado from './Form/BuscarEmpleadoForm.vue';
import CardDatosEmpleado from './Partials/DatosEmpleado.vue';
import DisponibilidadCreditos from './Partials/DisponibilidadCreditos.vue';

export default {
  name: 'ConsultarEmpleados',

  components: {
    FormBuscarEmpleado,
    CardDatosEmpleado,
    AlertEmpleadoNoRegistrado,
    AlertDatosDesactualizados,
    DisponibilidadCreditos,
  },

  data() {
    return {
      form: {
        identificacion: null,
      },
      datosEmpleadoCard: {
        showCard: false,
        empleadoCard: {},
      },
      empleadoNoRegistradoAlert: {
        showAlert: false,
        mensaje: '',
        identificacion: '',
      },
      empleadoRetiradoAlert: {
        showAlert: false,
      },
      datosDesactualizadosAlert: {
        showAlert: false,
        nitCompania: '',
        empresa: {},
        empleadoAlert: {},
      },
      disponibilidadCreditosCard: {
        showCard: false,
        convenios: [],
        empleadoData: {},
      },
      dataUser: {},
      loadingConsulta: false,
    };
  },

  computed: {
    estaBotonConsultarDeshabilitado() {
      return this.loadingConsulta || !this.form.identificacion;
    },

    puedeVerCardDatosEmpleado() {
      return (
        !this.loadingConsulta &&
        this.datosEmpleadoCard.showCard &&
        !this.datosDesactualizadosAlert.showAlert &&
        !this.empleadoRetiradoAlert.showAlert
      );
    },

    puedeVerDisponibilidadCreditos() {
      return (
        !this.loadingConsulta &&
        this.disponibilidadCreditosCard.showCard &&
        this.disponibilidadCreditosCard.convenios &&
        !this.datosDesactualizadosAlert.showAlert &&
        !this.empleadoRetiradoAlert.showAlert &&
        this.disponibilidadCreditosCard.empleadoData?.data
      );
    },
  },

  methods: {
    async consultarEmpleado() {
      this.disponibilidadCreditosCard.convenios = [];

      this.ocultarAlertas();

      if (!this.$refs.refFormBuscarEmpleado.validateForm()) {
        return;
      }

      const { identificacion } =
        this.$refs.refFormBuscarEmpleado.getIdentificacionInput();
      this.form.identificacion = identificacion || null;

      try {
        this.loadingConsulta = true;
        const dataEmpleado = await this.obtenerInfoEmpleado(
          this.form.identificacion
        );

        this.disponibilidadCreditosCard.empleadoData = dataEmpleado;

        await this.user();

        if (this.disponibilidadCreditosCard.convenios.length > 0) {
          this.disponibilidadCreditosCard.showCard = true;
        }

        if (dataEmpleado.data) {
          if (dataEmpleado.data.estaRetirado) {
            this.mostrarAlertaEmpleadoRetirado();
            return;
          }

          Object.assign(this.datosEmpleadoCard.empleadoCard, dataEmpleado.data);
          this.datosDesactualizadosAlert.nitCompania =
            dataEmpleado.data.NitCompañia;
          this.empresa = await this.getEmpresaByNit(
            this.datosDesactualizadosAlert.nitCompania
          );

          this.validarFechaActualizacion();

          const descTipoContrato = this.obtenerDescripcionContrato(
            dataEmpleado.data.TipoContrato._id
          );
          this.$set(
            this.datosEmpleadoCard.empleadoCard,
            'DescTipoContrato',
            descTipoContrato
          );

          this.datosEmpleadoCard.showCard = true;
          this.empleadoNoRegistradoAlert.showAlert = false;
        } else if (dataEmpleado.message && this.form.identificacion) {
          this.mostrarAlertaEmpleadoNoRegistrado(dataEmpleado.message);
        }
      } catch (error) {
        console.error('Error al consultar el empleado:', error);
      } finally {
        this.loadingConsulta = false;
      }
    },

    async obtenerInfoEmpleado(identificacion) {
      try {
        return await empleadoService.buscarPorDocumento(identificacion);
      } catch (error) {
        console.error('Error al obtener información del empleado:', error);
      }
    },

    async getEmpresaByNit(nit) {
      const buscarEmpresaPorNit = await empresaService.buscarTodos({ nit });
      const empresaPorNit = buscarEmpresaPorNit.data?.[0] || null;
      return empresaPorNit;
    },

    actualizarIdentificacionInput(valor) {
      this.form.identificacion = valor;
    },

    validarFechaActualizacion() {
      if (!this.empresa?.ultima_fecha_actualizacion) {
        return;
      }

      if (!empresaEstaActualizada(this.empresa)) {
        this.datosEmpleadoCard.showCard = false;
        this.disponibilidadCreditosCard.showCard = false;
        this.datosDesactualizadosAlert.showAlert = true;
        this.datosDesactualizadosAlert.empleadoAlert =
          this.datosEmpleadoCard.empleadoCard;
        this.empleadoNoRegistradoAlert.showAlert = false;
        return;
      }

      this.datosDesactualizadosAlert.showAlert = false;
    },

    mostrarAlertaEmpleadoNoRegistrado(message) {
      this.empleadoNoRegistradoAlert.showAlert = true;
      this.datosEmpleadoCard.showCard = false;
      this.disponibilidadCreditosCard.showCard = false;
      this.datosDesactualizadosAlert.showAlert = false;
      this.empleadoRetiradoAlert.showAlert = false;
      this.empleadoNoRegistradoAlert.mensaje = message;
      this.empleadoNoRegistradoAlert.identificacion = this.form.identificacion;
    },

    mostrarAlertaEmpleadoRetirado() {
      this.empleadoRetiradoAlert.showAlert = true;
      this.datosEmpleadoCard.showCard = false;
      this.disponibilidadCreditosCard.showCard = false;
      this.datosDesactualizadosAlert.showAlert = false;
      this.empleadoNoRegistradoAlert.showAlert = false;
    },

    obtenerDescripcionContrato(tipoContrato) {
      const tiposContrato = {
        1: 'Término indefinido',
        2: 'Término fijo',
        3: 'OPS',
        4: 'Aprendizaje',
      };
      return tiposContrato[tipoContrato] || '';
    },

    limpiarFormulario() {
      this.ocultarAlertas();
    },

    ocultarAlertas() {
      this.datosEmpleadoCard.showCard = false;
      this.disponibilidadCreditosCard.showCard = false;
      this.empleadoNoRegistradoAlert.showAlert = false;
      this.datosDesactualizadosAlert.showAlert = false;
      this.empleadoRetiradoAlert.showAlert = false;
    },

    async user() {
      this.dataUser = await usuarioService.getUser(
        this.$store.state.usuario._id
      );
      if (this.disponibilidadCreditosCard.convenios.length > 0) return;
      await this.getConvenios();
    },

    async getConvenios() {
      const empresasConConvenios = await empresaService.buscarTodos({
        tieneConvenio: true,
      });
      const listadoConvenios = empresasConConvenios.data;
      const conveniosUnicos = new Map();
      const conveniosPorNit = new Map(
        listadoConvenios.map(convenioItem => [convenioItem.nit, convenioItem])
      );

      for (const usuarioConvenio of this.dataUser.empresas) {
        const convenioEncontrado = conveniosPorNit.get(usuarioConvenio.nit);
        if (!convenioEncontrado) continue;

        for (const sucursal of convenioEncontrado.sucursales) {
          const idUnico = `${convenioEncontrado._id}-${sucursal.sucursal_id}`;
          if (!conveniosUnicos.has(idUnico)) {
            conveniosUnicos.set(idUnico, {
              razon_social: sucursal.descripcion_sucursal,
              plazo_contrato_finalizar: sucursal.plazo_contrato_finalizar,
              plazo_minimo_credito: sucursal.plazo_minimo_credito,
            });
          }
        }
      }

      this.disponibilidadCreditosCard.convenios = Array.from(
        conveniosUnicos.values()
      );
    },
  },
};
</script>
